module.exports = __webpack_public_path__ + "img/teacher-sample-m-4-vi-VN.6ea8bbfc.png";